import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { CartControllerService } from '../../services/cart-controller/cart-controller.service';
import { PartListControllerService } from '../../services/part-list-controller/part-list-controller.service';
import { PartModel } from '../../services/project-controller/project-controller';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';

@Component({
  selector: 'selected-part-list-bar',
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, MatBadgeModule],
  templateUrl: './selected-part-list-bar.component.html',
  styleUrl: './selected-part-list-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedPartListBarComponent implements OnInit, OnDestroy {
  public row: InputSignal<boolean> = input(false);

  public selectedPartList: Array<PartModel> = [];
  public choicePartList: Array<PartModel> = [];

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private partListController: PartListControllerService,
    private canvasController: CanvasControllerService,
    private cart: CartControllerService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.partListController.selectedPartList$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((selectedPartList) => {
        this.selectedPartList = selectedPartList;
        this.cd.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this._unsubscribeAll.unsubscribe();
  }

  onClickDelete(part: PartModel): void {
    part.isSelected = false;
    this.partListController.removePart(part);
    this.canvasController.removeModel(part);
  }

  onClickSelectedPart(part: PartModel): void {
    if (!this.choicePartList.includes(part)) this.choicePartList.push(part);
    else this.choicePartList = this.choicePartList.filter((p) => p !== part);
    this.cd.markForCheck();
  }

  onClickAddCart(): void {
    this.choicePartList?.forEach((part: PartModel) => {
      if (!part.marketplaceProduct) return;
      if (!part.marketplaceProduct.channel) return;
      if (!part.marketplaceProduct.variantId) return;

      this.cart
        .addCart(part.marketplaceProduct?.channel, part.marketplaceProduct?.variantId, 1)
        .then((success: boolean) => {
          console.log(`Cart Add [${part.title}]: ${success}`);
        });
    });
  }
  onClickClear(): void {
    console.log(this.choicePartList);
    this.choicePartList.forEach((part: PartModel) => {
      this.onClickDelete(part);
    });
    this.choicePartList = [];
    this.cd.markForCheck();
  }
}
